module.exports = ".flash-element {\n  width: auto;\n  font-size: 90%;\n  margin: 0;\n  padding: 0; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/admin/admin-products/admin-product-list/admin-product-list.component.scss
// module id = ./src/app/components/admin/admin-products/admin-product-list/admin-product-list.component.scss
// module chunks = main